/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        /*--------------------------------------------------------------------------*
         *
         *  SmoothScroll JavaScript Library V2
         *
         *  MIT-style license.
         *
         *  2007-2011 Kazuma Nishihata
         *  http://www.to-r.net
         *
         *--------------------------------------------------------------------------*/

        new function(){

          var attr ="data-tor-smoothScroll";//for html5 , if you can't use html5 , this value change "class"
          var attrPatt = /noSmooth/;
          var d = document;//document short cut

          /*
           *add Event
           -------------------------------------------------*/
          function addEvent(elm,listener,fn){
            try{ // IE
              elm.addEventListener(listener,fn,false);
            }catch(e){
              elm.attachEvent(
                  "on"+listener,function(){
                    fn.apply(elm,arguments)
                  }
              );
            }
          }

          /*
           *Start SmoothScroll
           -------------------------------------------------*/
          function SmoothScroll(a){
            if(d.getElementById(a.rel.replace(/.*\#/,""))){
              var e = d.getElementById(a.rel.replace(/.*\#/,""));
            }else{
              return;
            }

            //Move point
            var end=e.offsetTop
            var docHeight = d.documentElement.scrollHeight;
            var winHeight = window.innerHeight || d.documentElement.clientHeight
            if(docHeight-winHeight<end){
              var end = docHeight-winHeight;
            }

            //Current Point
            var start=window.pageYOffset || d.documentElement.scrollTop || d.body.scrollTop || 0;


            var flag=(end<start)?"up":"down";

            function scrollMe(start,end,flag) {
              setTimeout(
                  function(){
                    if(flag==="up" && start >= end){
                      start=start-(start-end)/20-1;
                      window.scrollTo(0,start)
                      scrollMe(start,end,flag);
                    }else if(flag==="down" && start <= end){
                      start=start+(end-start)/20+1;
                      window.scrollTo(0,start)
                      scrollMe(start,end,flag);
                    }else{
                      scrollTo(0,end);
                    }
                    return ;
                  }
                  ,10
              );

            }

            scrollMe(start,end,flag);

          }

          /*
           *Add SmoothScroll
           -------------------------------------------------*/
          addEvent(window,"load",function(){
            var anchors = d.getElementsByTagName("a");
            for(var i = 0 ,len=anchors.length; i<len ; i++){
              if(!attrPatt.test(anchors[i].getAttribute(attr)) &&
                  anchors[i].href.replace(/\#[a-zA-Z0-9_]+/,"") === location.href.replace(/\#[a-zA-Z0-9_]+/,"")){
                anchors[i].rel = anchors[i].href;
                anchors[i].href = "javascript:void(0)";
                anchors[i].onclick=function(){SmoothScroll(this)}
              }
            }
          });

        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        $(".slider").slick({
          //lazyLoad: 'ondemand',
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 970,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
